// vto.js

/* Configuration for widget */
var params = {
  apiKey: "TN8KNZCNU3F2Kzs6PUa1r3g0jsmwwpF5pY7kkQoQ",
  
  popupIntegration: {
    centeredHorizontal: true,
    centeredVertical: true,
    width: "640px",
    height: "480px",
  },
};

window.onload = function () {
  window.fitmixInstance = FitMix.createWidget("fitmix-container", params, function () {
    console.log("FitmixWidget creation complete!");
  });
  
  mainSetup();
};

/*  Main logic: availability check, UI toggles, events */
async function mainSetup() {

  const wrapper = document.getElementById("vto-wrapper");
  if (!wrapper) {
    console.warn("No #vto-wrapper found in the DOM. Ensure the HTML is present!");
    return;
  }
  const productSku = wrapper.dataset.sku || "8053672909258"; // fallback


  const frameIsAvailable = await isFrameAvailable(productSku);
  console.log(`Frame ${productSku} available? =>`, frameIsAvailable);


  const vtoButton = document.getElementById("vto-button");
  const modal = document.getElementById("vto-modal");
  const womanButton = document.getElementById("vto-woman");
  const manButton = document.getElementById("vto-man");
  const pdSlider = document.getElementById("vto-pd-range");
  const pdValue = document.getElementById("vto-pd-value");
  const startBtn = document.getElementById("vto-start-button");

  if (
    !vtoButton ||
    !modal ||
    !womanButton ||
    !manButton ||
    !pdSlider ||
    !pdValue ||
    !startBtn
  ) {
    console.warn("Missing one or more DOM elements needed for the modal flow!");
    return;
  }


  if (frameIsAvailable) {
    vtoButton.style.display = "inline-block";
    vtoButton.disabled = false;
  } else {
    console.warn(`Frame SKU ${productSku} is not available. Button remains hidden.`);
    return;
  }


  vtoButton.addEventListener("click", () => {
    window.fitmixInstance.setFrame(productSku);
    console.log(`Frame set to ${productSku}`);
    modal.style.display = "flex"; 
  });


  let selectedGender = "m"; // default "m"
  womanButton.addEventListener("click", () => {
    selectedGender = "f";
    highlightGenderButton("f");
  });
  manButton.addEventListener("click", () => {
    selectedGender = "m";
    highlightGenderButton("m");
  });


  pdSlider.addEventListener("input", () => {
    pdValue.textContent = pdSlider.value;
  });


  startBtn.addEventListener("click", () => {
    const customPD = parseInt(pdSlider.value, 10) || 63;

    window.fitmixInstance.setUserInfo({
      gender: selectedGender,
      pupillaryDistance: customPD,
    });

    console.log("User info =>", { gender: selectedGender, pupillaryDistance: customPD });
    window.fitmixInstance.startVto("live");

    modal.style.display = "none";
  });
}


/* Check Availability from Fittingbox's Product */
async function isFrameAvailable(sku) {
  const fbApiKey = "TN8KNZCNU3F2Kzs6PUa1r3g0jsmwwpF5pY7kkQoQ";
  const url = `https://product-api.fittingbox.com/glasses-metadata/availability?apiKey=${fbApiKey}&uidList=${sku}`;
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error("Failed to fetch availability");
    const data = await response.json();
    return data[0]?.available === true;
  } catch (err) {
    console.error("Error in isFrameAvailable:", err);
    return false;
  }
}

function highlightGenderButton(g) {
  const womanButton = document.getElementById("vto-woman");
  const manButton = document.getElementById("vto-man");


  womanButton.classList.remove("selected");
  manButton.classList.remove("selected");


  if (g === "f") {
    womanButton.classList.add("selected");
  } else {
    manButton.classList.add("selected");
  }
}
